export type InsightsPlusNodeType = {
  reportTypes: [string]
}

/**
 * This utility function will slugify ReportTypes, join with ","
 * and return as a string
 * @param reportTypes
 */
export const getReportTypesSlugs = (reportTypes: [string]) => {
  return reportTypes
    .map((reportType: string) => {
      const slugValue: string = reportType
        .trim()
        .toLowerCase()
        .replace(/ /g, '-')
      return `insights/${slugValue}`
    })
    .join(',')
}
/**
 * This utility function will get the ReportTypes from nodes
 * and return as a list of strings in an array
 * @param reportTypes
 */
export const getReportTypes = (insightsNodes: [InsightsPlusNodeType]) => {
  let reportTypeList: string[] = []
  insightsNodes &&
    insightsNodes.forEach((insightsNode: InsightsPlusNodeType) => {
      const { reportTypes } = insightsNode
      reportTypeList = reportTypeList.concat(reportTypes)
    })

  return reportTypeList
}
/**
 * This utility function will slugify ReportTypes, join with ","
 * and return as a string
 * @param reportTypes
 */
export const getReportTypesSearchNodeSlugs = (
  insightsNodes: [InsightsPlusNodeType]
) => {
  let reportTypeSlugs: string[] = []
  insightsNodes &&
    insightsNodes.forEach((insightsNode: InsightsPlusNodeType) => {
      const { reportTypes } = insightsNode
      reportTypeSlugs = reportTypeSlugs.concat(reportTypes)
    })
  return reportTypeSlugs
    .map((reportType: string) => {
      const slugValue: string = reportType
        .trim()
        .toLowerCase()
        .replace(/ /g, '-')
      return `insights/${slugValue}`
    })
    .join(',')
}
export default getReportTypes
